import config from "../../config/config";
import connection from "../../utils/connection";

export default async function esAdminOConfig() {
  let response = {};
  try {
    const responseGet = await connection({
      method: "POST",
      url: `/perfiles/EsAdminOConfig`,
    });
    if (responseGet.status === 401) return (window.location.href = `${config.URL.STOP_APP_URL}/login`);
    response = responseGet;
  } catch (error) {
    console.error("Error en esAdminOConfig", error);
    response = error.response;
  }

  return response;
}
